<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />
          {{ /* table controllerscontrollers */ }}
          <div>
            <div class="form-group form-inline pull-left mb-2">
              <b-dropdown variant="primary" size="sm" class="vgt-left-btn" no-caret>
                <template slot="button-content">
                  Update Store
                </template>
                <span v-for="integration in integrations" :key="integration.id">
                  <b-dropdown-item @click="sync(integration.id, integration.marketplace_id)">
                    <b-img :src="integration.marketplace_logo" height="32" />
                    <strong>{{ integration.nickname ? integration.nickname : integration.name }}</strong>
                    &nbsp;&nbsp;
                    <span class="glyphicon glyphicon-refresh"></span>
                    <br />
                    <em> Last Updated: {{ integration.last_synced_at | readableDate }}</em>
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                </span>
              </b-dropdown>
              &nbsp;
              <b-input-group size="sm">
                <div class="input-group-prepend">
                  <div class="input-group-text vgt-left-btn">Marketplace</div>
                </div>
                <b-form-select v-model="serverParams.marketType" :options="marketplaceOptions"
                  @change="onVGTMarketplaceChange"></b-form-select>
              </b-input-group>
              &nbsp;
              <b-button class="vgt-left-btn" size="sm" to="/orders/batch-label-history">Batch Label History</b-button>
              &nbsp;

              <b-btn class="vgt-left-btn" size="sm" @click="showModifyPackageModal"
                :disabled="serverParams.ids.length < 2">
                Modify
              </b-btn>&nbsp;

              <!-- <b-button
                  href
                  class="vgt-left-btn vgt-green"
                  size="sm"
                  :disabled="canPrint"
                  @click="onShowPrintModal"
                >Batch Ship</b-button>
                &nbsp; -->

              <b-dropdown text="Batch Ship" class="vgt-delete" size="sm" :disabled="canPrint">
                <b-dropdown-item @click="onShowPrintModal">Outbound only</b-dropdown-item>
                <b-dropdown-item @click="onShowPrepaidReturnModal">Outbound + Prepaid Return</b-dropdown-item>
              </b-dropdown>&nbsp;

              <b-button href class="vgt-left-btn vgt-red" size="sm" :disabled="serverParams.ids.length < 1"
                @click="deleteOrders">Delete</b-button>
              &nbsp;
            </div>

            <div class="form-group form-inline pull-right mb-2">
              <b-input-group>
                <b-input class="table-search border-right-0 border" v-model="searchkw" size="sm" placeholder="Search"
                  @keypress.enter="onTableSearch" />
                <b-input-group-append>
                  <b-button variant="outline-error" class="border-left-0 border" @click="onVGTClearSearch">
                    <i :class="['fa', 'fa-times', { 'opacity-0': !searchkw }]"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-btn variant="success" @click="onTableSearch">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
              &nbsp;
              <b-dropdown id="dropdown-1" text="Edit Columns" size="sm" class="vgt-right-btn">
                <b-dropdown-form style="padding-left: 0.5rem">
                  <b-form-checkbox-group v-model="selectedColumns">
                    <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                      {{ col.label }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                  <b-dropdown-item-button @click="onVGTColumnSelect">
                    <b-button size="sm" class="vgt-right-bnt" block>Apply</b-button>
                  </b-dropdown-item-button>
                </b-dropdown-form>
              </b-dropdown>
            </div>
          </div>
          {{ /* table controllerscontrollers */ }}
          <div class="clearfix"></div>
          <!-- batch print -->
          <b-progress :max="100" v-if="batch_progress.value" style="margin-bottom: .75rem;" animated striped>
            <b-progress-bar :value="batch_progress.value" variant="success">
              <span style="color:#212529;">{{ batch_progress.label }}...</span>
            </b-progress-bar>
          </b-progress>
          <!-- shopify -->
          <b-progress :max="100" v-if="shopify_progress.value" style="margin-bottom: .75rem;" animated striped>
            <b-progress-bar :value="shopify_progress.value" variant="success">
              <span style="color:#212529;">{{ shopify_progress.label }}...</span>
            </b-progress-bar>
          </b-progress>
          <!-- ebay -->
          <b-progress :max="100" v-if="ebay_progress.value" style="margin-bottom: .75rem;" animated striped>
            <b-progress-bar :value="ebay_progress.value" variant="success">
              <span style="color:#212529;">{{ ebay_progress.label }}...</span>
            </b-progress-bar>
          </b-progress>
          <!-- etsy -->
          <b-progress :max="100" v-if="etsy_progress.value" style="margin-bottom: .75rem;" animated striped>
            <b-progress-bar :value="etsy_progress.value" variant="success">
              <span style="color:#212529;">{{ etsy_progress.label }}...</span>
            </b-progress-bar>
          </b-progress>
          <!-- batch update -->
          <b-progress :max="100" v-if="update_progress.value" class="mb-2" animated striped>
            <b-progress-bar :value="update_progress.value" variant="success">
              <span style="color:#212529;">{{ update_progress.label }}...</span>
            </b-progress-bar>
          </b-progress>

          <div class="card mb-3" v-if="summary_text">
            <div class="card-body">
              <span v-html="summary_text"></span>
              <button type="button" class="close red-circle-close" @click="summary_text = ''">×</button>
            </div>
          </div>

          <b-row class="justify-content-end">
            <b-col sm="auto" style="z-index: 999;">
              <b-input-group class="mb-2">
                <div class="db-help import">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                    <template slot="button-content">
                      <b-img src="/images/icons/information.png" />
                    </template>
                    <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                      <ul>
                        <li>Maximum selected records is {{ serverParams.perPage }}</li>
                        <li>Records selected has to be within the current table</li>
                      </ul>
                    </b-dropdown-text>
                  </b-dropdown>
                </div>
                <b-form-input class="table-search border-right-0 border" size="sm" v-model="customRange"
                  placeholder="Custom Range (e.g. 1-5, 10)" style="width: 200px;" @keyup.enter="customSelectedRows" />
                <b-input-group-append>
                  <b-button variant="outline-error" class="border-left-0 border" @click="(e) => {
                    if (customRange) {
                      customRange = '';
                    }
                  }">
                    <i :class="['fa', 'fa-times', { 'opacity-0': !customRange }]"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>

          {{ /* VGT */ }}
          <vue-good-table ref="vgt" mode="remote" :columns="columns" :rows="rows"
            styleClass="vgt-table striped bordered condensed" max-height="70vh"
            :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
            :search-options="{ enabled: true, externalQuery: searchTerm }"
            :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPage: serverParams.perPage, perPageDropdown: [50, 100, 250], dropdownAllowAll: false }"
            :totalRows="totalRecords" :line-numbers="true" @on-search="onVGTSearch"
            @on-selected-rows-change="onVGTSelected" @on-page-change="onVGTPageChange" @on-sort-change="onVGTSortChange"
            @on-column-filter="onVGTColumnFilter" @on-per-page-change="onVGTPerPageChange">
            <div slot="emptystate"> N/A </div>
            <template slot="table-row" slot-scope="props">
              <!-- ACTION -->
              <span v-if="props.column.field === 'id'">
                <button class="btn btn-danger btn-xs view" @click="showOrder(props.row.id)"
                  v-if="props.row.total_price < 1">Edit</button>
                <button class="btn btn-success btn-xs view" @click="showOrder(props.row.id)" v-else>Edit</button>
              </span>
              <span v-else-if="props.column.field === 'print'">
                <b-btn size="xs" variant="success" class="view" @click="printOrders(props.row.id)"
                  :disabled="props.row.total_price < 1">Ship</b-btn>
              </span>
              <span v-else-if="props.column.field === 'total_weight'">
                {{ getWeight(props.row.total_weight).lb }}lb
                {{ getWeight(props.row.total_weight).oz }}oz
              </span>
              <span v-else-if="props.column.field === 'marketplace'">
                <img v-if="props.row.marketplace" :src="props.row.marketplace.img"
                  :height="props.row.marketplace.height" :width="props.row.marketplace.weight" class="img-responsive" />
                <span v-else>.</span>
              </span>
              <span v-else-if="props.column.field === 'address'">
                {{ props.row.address.address1 }} <br />
                {{ props.row.address.address2 }} <br />
                {{ props.row.address.address3 }}
              </span>
              <span v-else-if="props.column.field === 'name'">
                <span v-if="props.row.name.name.trim()">
                  {{ props.row.name.name }} <br />
                </span>
                {{ props.row.name.company }}
              </span>
              <span v-else-if="props.column.field === 'confirmation'">
                {{ getSignatureName(props.row) }}
              </span>
              <span v-else-if="props.column.field === 'age'">
                {{ calculateAge(props.row.created_at) }}
              </span>
              <span v-else-if="props.column.field === 'created_at'">
                {{ props.row.created_at | readableDate }}
              </span>
              <span v-else-if="props.column.field === 'total_price'">
                {{ format.price(props.row.total_price) }}
              </span>
              <span
                v-else-if="['declared_value', 'rate', 'insurance_price', 'tracking_price'].includes(props.column.field)">
                {{ format.price(props.row[props.column.field]) }}
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

          </vue-good-table>
          {{ /* VGT */ }}

        </b-card>
      </div>
    </div>

    <PrintingProcess ref="viewPrinterSettingModal" :selected.sync="selected" printed_on="E-commerce" @print="onPrint" />

    <div v-if="shown">
      <ShowOrder ref="viewOrderModal" :key="shown.id" :orderobj="shown" @saveAndClose="onSaveAndClose"
        @cancel="onSaveAndClose" @print="onModalPrint"></ShowOrder>
    </div>

    <ModifyPackage ref="viewModifyPackageModal" @save="saveOrders" />

    <PrepaidReturnModal ref="viewPrepaidReturnModal" @save="onSavePrepaidReturn" />
  </div>
</template>
<style lang="scss">
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  &+.calendar-root {
    .input-date {
      display: none;
    }

    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}

.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }

  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import ShowOrder from "./ShowIntegrationModal";
import lStore from './Mixins/lStore';
import moment from "moment";
import Cookies from 'js-cookie';
import hash from 'object-hash';
import { mapGetters, mapActions, mapMutations } from "vuex";
import { VueGoodTable } from 'vue-good-table';

import PrintingProcess from './Import/PrintingProcess';
import ModifyPackage from '../../components/Modals/ModifyPackage';
import PrepaidReturnModal from '../../components/Modals/PrepaidReturnModal';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ShowOrder,
    PrintingProcess,
    ModifyPackage,
    PrepaidReturnModal,
  },
  data() {
    return {
      totalRate: 0,
      totalInsurance: 0,
      customRange: '',
      summary_text: '',
      isLoading: false,
      isBulkPrint: false,
      // value could be 3 for shipped,4 for voided,5 for returns
      orderType: {
        id: 2,
        name: 'integration',
      },
      // for modal
      shown: null,
      shownObjs: {},
      integrations: [],
      selectedColumns: [
        "marketplace", "order_number", "created_at", "name", "item",
        "shipping_service", "package_type", "total_weight", "total_price",
      ],
      selected_text: 'Records Selected',
      selection_class: 'vgtSelectInfo',
      selected: [],
      searchkw: '',
      searchTerm: '',
      serverParams: {
        columns: null,
        marketType: 'all',
        dateRange: null,
        searchTerm: '',
        ids: [],
        columnFilters: null,
        sort: null,
        page: null,
        perPage: 50,
      },
      marketplaceOptions: [],
      totalRecords: 0,
      rows: [],
      columns: [
        {
          field: 'id', label: "Actions",
          thClass: "vgt-headers narrower",
          sortable: false,
        },
        {
          field: 'print', label: "1-Click Print",
          thClass: "vgt-headers narrower",
          sortable: false,
        },
        {
          field: 'marketplace', label: "Marketplace",
          thClass: "vgt-headers",
        },
        {
          field: 'origin_address', label: "Origin Address",
          thClass: "vgt-headers", hidden: true,
        },
        {
          field: 'origin_postal', label: "Origin Postal",
          thClass: "vgt-headers", hidden: true,
        },
        {
          field: 'order_number', label: "Order Number",
          sortable: true, thClass: "vgt-headers",
        },
        {
          field: 'ref_id', label: "Reference ID",
          sortable: false, thClass: "vgt-headers narrow", hidden: true,
        },
        {
          field: 'age', label: "Age",
          thClass: "vgt-headers narrow",
        }, {
          field: 'created_at', label: "Order Date",
          thClass: "vgt-headers wide",
        }, {
          field: 'name', label: "Recipient",
          thClass: "vgt-headers",
        }, {
          field: 'address', label: "Address",
          thClass: "vgt-headers widest",
          hidden: true,
        }, {
          field: 'shipping_service', label: "Service Class",
          sortable: false,
          thClass: "vgt-headers",
        }, {
          field: 'package_type', label: "Package Type",
          sortable: false,
          thClass: "vgt-headers narrow",
        }, {
          field: 'total_weight', label: "Weight",
          sortable: false,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'declared_value', label: "Declared Value",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'insurance_price', label: "Insurance",
          sortable: false, hidden: true,
          thClass: "vgt-headers narrow",
        },
        {
          field: 'rate', label: "Shipping Rate",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'surcharge', label: "Surcharge",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'tracking_price', label: "Additional Tracking",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'total_price', label: "Total Cost",
          sortable: false,
          thClass: "vgt-headers",
        },
        {
          field: 'confirmation', label: "Signature",
          sortable: false, hidden: true,
          thClass: "vgt-headers narrowest",
        },
        {
          field: 'dimension', label: "Dimensions",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        },
        {
          field: 'label_sticky', label: "Custom Field 1",
          sortable: true, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'label_sticky_2', label: "Custom Field 2",
          sortable: true, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'email', label: "Email",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'phone', label: "Phone",
          sortable: false, hidden: true,
          thClass: "vgt-headers",
        }, {
          field: 'description', label: "Description",
          sortable: true, hidden: true,
          thClass: "vgt-headers widest",
        }, {
          field: 'delivery_zone', label: "Delivery Zone",
          sortable: true, hidden: true,
          thClass: "vgt-headers",
        }
      ],
    }
  }, // end of data
  watch: {
    searchkw: function (newVal, oldVal) {
      if (!newVal || !newVal.length) {
        this.onVGTClearSearch()
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee: "getEmployeeName",
      balance: "getUserBalance",
      ebay_progress: "ws/getEbayProgress",
      etsy_progress: "ws/getEtsyProgress",
      shopify_progress: "ws/getShopifyProgress",
      batch_progress: "ws/getBatchPrintProgress",
      update_progress: "ws/getUpdateProgress",
      ebaySubscription: "ws/getEbaySubscription",
      etsySubscription: "ws/getEtsySubscription",
      shopifySubscription: "ws/getShopifySubscription",
      batchPrintSubscription: "ws/getBatchPrintSubscription",
      updateSubscription: "ws/getUpdateSubscription",
      shipsurance: "getShipsurance",
    }),
    canPrint() {
      const ids = this.serverParams.ids;
      if (ids.length > 0) {
        const withInvalid = this.rows.map(r => {
          const rate = parseFloat(r.rate);
          return ids.indexOf(r.id) > -1 && !rate ? r : null
        }).some(i => i != null);
        return withInvalid || ids.length <= 1;
      }
      return true;
    },
    shipping_service_options() {
      return this.$store.state.shipping_services
        .map(shippingService => {
          return {
            value: shippingService.id,
            text: shippingService.name
          };
        })
        .sort((a, b) => {
          return (
            sorting.services[a.value.code] - sorting.services[b.value.code]
          );
        });
    },
    columnSelection() {
      return this.columns.map(v => {
        const { field, label } = v;
        if (!['id', 'print'].includes(v.field)) return { field, label };
      }).filter(v => !!v);
    },
  },
  async mounted() {
    console.log('user', this.user.shipping_label_format);
    const cols = lStore.get(`${this.orderType.name}Columns`);
    if (cols) {
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    const pP = lStore.get(`${this.orderType.name}PerPage`);
    if (pP) {
      this.serverParams.perPage = pP;
    }
    await Promise.all([
      this.fetchIntegrations(),
      this.fetchOrders(),
      this.getMarketPlaces(),
      // this.showOrder(12321),
    ]);

    const chan = this.batchPrintSubscription;
    chan.on("batch_data", ({ summary, errors }) => {
      if (errors.length == 1) {
        // single print?
        const err = errors[0].name
        this.$emit("alert", {
          message: err,
          type: "danger"
        });
      }
      // this.summary_text = summary;
      this.fetchOrders();
      this.refreshEcommerceCount();
    });

    const update_chan = this.updateSubscription;
    update_chan.on("done", async () => {
      try {
        const selectedRows = this.$refs.vgt.selectedRows
        const ids = selectedRows.map(r => r.id)
        await this.fetchOrders();
        this.rows.forEach((r, i) => {
          if (ids.includes(r.id)) {
            this.$set(this.rows[i], 'vgtSelected', true);
          }
        })
        this.refreshEcommerceCount();
      } catch (e) { }
    });
    update_chan.on("update_data", ({ summary }) => {
      this.summary_text = summary;
    });
  },
  methods: {
    ...mapActions([
      "addPrintJob",
      "refreshUserBalance",
      "refreshEcommerceCount",
    ]),
    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTSelected(params) {
      console.log('on select', params);
      if (params.selectedRows.length > 0) {
        const ids = params.selectedRows.map(v => v.id);
        this.updateVGTParams({ ids });
        console.log('on select', ids, this.serverParams.ids);

        this.totalRate = params.selectedRows.map(v => v.rate).reduce((a, b) => parseFloat(a) + parseFloat(b))
        this.totalInsurance = params.selectedRows.map(v => v.insurance_price).reduce((a, b) => parseFloat(a) + parseFloat(b))

        if (this.totalRate > this.balance || (this.user.shipsurance_terms && this.totalInsurance > this.shipsurance)) {
          // if (total > 20) {  // for color testing
          this.selection_class = 'vgtSelectInfoDanger';
          this.disablePrint = true;
        } else {
          this.selection_class = 'vgtSelectInfo';
          this.disablePrint = false;
        }

        this.selected_text = `Records Selected (Total Cost: ${this.format.price(this.totalRate)})`;
        if (this.user.shipsurance_terms) {
          this.selected_text = `${this.selected_text} (Total Insurance Cost: ${this.format.price(this.totalInsurance)})`;
        }
      } else {
        this.updateVGTParams({ ids: [] });
      }
    },
    onVGTSearch(params) {
      console.log('on search', params);
      this.updateVGTParams({ searchTerm: params.searchTerm });
      this.fetchOrders();
    },
    onVGTClearSearch() {
      this.searchkw = '';
      this.searchTerm = '';
    },
    async onTableSearch() {
      this.searchTerm = this.searchkw
    },
    onVGTPageChange(params) {
      console.log('on pagination', params);
      this.updateVGTParams({ page: params.currentPage });
      this.fetchOrders();
    },
    onVGTPerPageChange(params) {
      console.log('on per page change', params);
      this.updateVGTParams({ perPage: params.currentPerPage });
      lStore.set(`${this.orderType.name}PerPage`, params.currentPerPage);
      // needs to clear everything since since the number of pages is already invalid
      this.fetchOrders();
    },
    onVGTSortChange(params) {
      console.log('on sort change', params);
      if (!params.length) return
      const { field, type } = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.fetchOrders();
    },
    onVGTColumnFilter(params) {
      console.log('on columnfilter', params);
      this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTColumnSelect() {
      console.log('on selectColumns', this.selectedColumns);
      this.columns = this.columns.map(column => {
        if (column.field == 'id' || column.field == 'print') {
          column.hidden = false;
        } else {
          column.hidden = this.selectedColumns.includes(column.field) ? false : true;
        }
        return column;
      })
      this.updateVGTParams({ columns: this.selectedColumns });
      const cols = Object.assign({}, { columns: this.columns, selectedColumns: this.selectedColumns });
      lStore.set(`${this.orderType.name}Columns`, cols);
    },
    onVGTDateRangeSelected(params) {
      const { end, start } = params;
      console.log('on daterange start', start);
      console.log('on daterange end', end);
      this.updateVGTParams({ dateRange: [start, end] });
      // this.updateVGTParams(params);
      this.fetchOrders();
    },
    onVGTMarketplaceChange() {
      console.log('on marketplace change', this.serverParams.marketType);
      this.fetchOrders();
    }, // VGT EVENTS

    async fetchIntegrations() {
      let url = '/my-integrations';
      try {
        const { data } = await axios.get(url);
        this.integrations = data;
      } catch (e) {
        console.error(e);
      }
    },
    async sync(id, marketplace_id) {
      switch (marketplace_id) {
        case 1: // shopify
          try {
            const shopifyChan = this.shopifySubscription;
            console.log("sync shopify channel", shopifyChan);
            shopifyChan.emit("refresh", id);
            shopifyChan.on("shopify_sync_done", async () => {
              await this.fetchOrders();
              this.refreshEcommerceCount();
            });
          } catch (e) {
            console.error("Unable to connect to Shopify");
            if (confirm(`The browser has timed out and lost some connection to server. The application may experience difficulties.
              \r\nPlease refresh the page to resolve.`)) {
              document.location.reload();
            }
          }
          break;
        case 2: // ebay
          try {
            const eBayChan = this.ebaySubscription;
            eBayChan.emit("refresh", id);
            eBayChan.on("ebay_sync_done", async () => {
              await this.fetchOrders();
              this.refreshEcommerceCount();
            });
          } catch (e) {
            console.error("Unable to connect to Ebay");
            if (confirm(`The browser has timed out and lost some connection to server. The application may experience difficulties.
              \r\nPlease refresh the page to resolve.`)) {
              document.location.reload();
            }
          }
          break;
        case 25: // etsy
          try {
            const etsyChan = this.etsySubscription;
            etsyChan.emit("refresh", id);
            etsyChan.on("etsy_sync_done", async () => {
              await this.fetchOrders();
              this.refreshEcommerceCount();
            });
          } catch (e) {
            console.error("Unable to connect to Etsy");
            if (confirm(`The browser has timed out and lost some connection to server. The application may experience difficulties.
              \r\nPlease refresh the page to resolve.`)) {
              document.location.reload();
            }
          }
          break;
        default:
        // try{
        //   this.isLoading = true;
        //   let url = `/sync/integrations/${id}`;
        //   const response = await axios.get(url);
        //   console.log('sync response', response);
        //   await Promise.all([
        //     this.fetchOrders(),
        //     this.fetchIntegrations()
        //   ]);
        //   this.$emit("alert", {
        //     message: 'Finish Syncing From Store',
        //     type: "success"
        //   });
        // }catch(e){
        //   if(e.response && e.response.status === 504){
        //     this.$emit("alert", {
        //       message: "It's taking longer than expected. Try Reloading the page after 3-5 min.",
        //       type: "danger"
        //     });
        //   }else{
        //     this.$emit("alert", {
        //       message: 'Unable to sync, please try again later',
        //       type: "danger"
        //     });
        //   }
        // }finally{
        //   this.isLoading = false;
        // }
      }
      await this.fetchIntegrations()
      return;
    },
    async fetchOrders(page_url = `/orders-vgt`) {
      try {
        this.isLoading = true;
        const response = await axios.get(page_url, {
          params: Object.assign({}, { status: this.orderType.id, with_type: this.orderType.name }, this.serverParams)
        });
        const { data: { data, total } } = response;
        console.log(data, total);
        this.totalRecords = total;
        this.rows = data.map(order => {
          return this.mapToRows(order, this.orderType.id);
        });
      } catch (e) {
        console.error('error fetching orders', e);
      } finally {
        this.isLoading = false;
      }
    }, // get data from server
    mapToRows: function (order) {
      const pkgtypes = {
        PKG: 'Package',
        IRRPKG: 'Irregular Package',
        SOFTPACK: 'Cubic Soft Pack',
        FRE: 'Flat Rate Envelope',
        SFRB: 'Small Flat Rate Box',
        FRB: 'Medium Flat Rate Box',
        LFRB: 'Large Flat Rate Box',
        PFRENV: 'Flat Rate Padded Envelope',
        LGLFRENV: 'Flat Rate Legal Envelope',
        MLFRB: 'Military Large Flat Rate Box'
      };
      const origin_name = `${order.origin_first_name || ''} ${order.origin_last_name || ''}`;
      const origin_company = order.origin_company;
      let origin_address = '';

      if (origin_company && origin_name.trim()) origin_address = `${origin_company}, ${origin_name}`;
      else if (origin_company) origin_address = origin_company;
      else origin_address = origin_name;
      const pl = order.package_length;
      const pw = order.package_width;
      const ph = order.package_height;

      const svg_logos = [
        'amazon', 'big commerce', 'ebay', 'etsy', 'facebook marketplace', 'instagram',
        'paypal', 'shopify', 'walmart', 'square', 'squarespace', 'wix', 'woocommerce', 'x-cart'
      ]

      const marketplaceWH = {
        ebay: { w: 55, h: 25 },
        etsy: { w: 'auto', h: 30 },
        grandshipper: { w: 25, h: 30 },
        squarespace: { w: 27, h: 25 },
        whatnot: { w: 35, h: 20 },
        wix: { w: 42, h: 25 },
      }

      return {
        id: order.id,
        marketplace: order.marketplace_id ? {
          img: svg_logos.includes(order.marketplace_code)
            ? `/images/integrations/${order.marketplace_code}/logo.svg`
            : `/images/integrations/${order.marketplace_code}/table-icon.png`,
          id: order.marketplace_id,
          name: order.marketplace_name,
          height: marketplaceWH[order.marketplace_code] ? marketplaceWH[order.marketplace_code].h : 25,
          weight: marketplaceWH[order.marketplace_code] ? marketplaceWH[order.marketplace_code].w : 'auto',
        } : null,
        origin_postal: order.origin_id ? order.origin_postal_origin : '',
        order_number: order.order_number,
        ref_id: order.ref_id,
        description: order.description,
        created_at: order.created_at,
        // shipped_at: order.shipped_at,
        name: {
          name: `${order.shipping_address_first_name || ''} ${order.shipping_address_last_name || ''}`,
          company: order.shipping_address_company || ''
        },
        address: {
          address1: `${order.shipping_address_address} ${order.shipping_address_address2 || ''}`,
          address2: `${order.shipping_address_city} ${order.shipping_address_province}`,
          address3: `${order.shipping_address_country} ${order.shipping_address_postal_code}`
        },
        shipping_address_country: order.shipping_address_country, // needed for dropdown
        shipping_service_code: order.shipping_service_code, // needed for dropdown
        shipping_service_id: order.shipping_service_id, // needed for dropdown
        shipping_service: order.shipping_service_name,
        rate: order.rate,
        surcharge: order.surcharge,
        package_type: order.package_type ? pkgtypes[order.package_type] : '',
        package_type_code: order.package_type,
        confirmation: order.confirmation,
        total_weight: order.total_weight,
        dimension: (pw && pl && ph) ? `${order.package_length} x ${order.package_width} x ${order.package_height}` : 'N/A',
        tracking_price: order.tracking_price,
        insurance_price: order.insurance_price,
        declared_value: order.declared_value,
        total_price: order.total_price,
        label_sticky: order.label_sticky,
        label_sticky_2: order.label_sticky_2,
        email: order.shipping_address_email,
        phone: order.shipping_address_phone,
        origin_address,
        printed_by: order.printed_by,
        delivery_zone: order.delivery_zone,
      }
    }, // DATA
    // MARKETPLACE OPTIONS
    async getMarketPlaces() {
      const mOptions = sessionStorage.getItem('marketplace_options');
      if (mOptions) {
        this.marketplaceOptions = JSON.parse(mOptions);
      } else {
        console.log('getting marketplace options');
        const { data } = await axios.get('/marketplaces-vgt');
        console.log('marketplaces', data);
        const marketplaces = data.map(m => {
          const text = `<u>${m.name}</u>`;
          return {
            value: m.id,
            text,
          };
        });

        const options = [{ value: "all", text: "All" }, ...marketplaces];
        console.log('options', options);
        sessionStorage.setItem('marketplace_options', JSON.stringify(options));
        this.marketplaceOptions = options;
      }
    }, // MARKETPLACE OPTIONS
    getOrderById(orderId) {
      const order = this.rows.find(o => o.id === orderId);
      return order || null;
    },
    onEditOrderReset(e) { },
    showImportModal() {
      this.$refs.importOrdersModal.show();
    },
    // async printOrder(orderId) {
    //   this.isLoading = true;
    //   // get the id to be deleted in rows later if successful
    //   try{
    //     const response = await axios.post("printlabel/" + orderId);
    //     // this.shipper_addresses = response.data;
    //     //this.order.label_print = response.data.documents[0].contents;

    //     // Add to printer
    //     console.log('print response', response);
    //     const decoded = response.data;
    //     decoded.type = ''; // force print?
    //     this.addPrintJob(decoded);
    //     // delete the printed order from the list
    //     // window.open(response.data.label);
    //   } catch(e){
    //     console.error(e);
    //     let message = e.response.data.message;
    //     if (e.response.data.errors) {
    //       message += ": ";
    //       message += Object.values(e.response.data.errors).join(" ");
    //     }
    //     this.$emit("alert", { message: message, type: "danger" });
    //     // alert(JSON.parse(error.response.data.message)[0].additionalInfo);
    //   } finally {
    //     this.isLoading = false;
    //     if(!this.isBulkPrint){
    //       this.fetchOrders();
    //       this.refreshUserBalance();
    //     }
    //   }
    // },

    onPrint(settings) {
      console.log("PRINT SETTING", settings);
      this.printOrders(null, settings);
    },

    onShowPrintModal() {
      if (this.serverParams.ids.length > 1) {
        this.$refs.viewPrinterSettingModal.show();
      } else {
        this.printOrders()
      }
    },

    onShowPrepaidReturnModal() {
      this.$refs.viewPrepaidReturnModal.show({
        ids: this.serverParams.ids,
        initialRate: this.totalRate,
        initialInsurance: this.totalInsurance
      });
    },

    onSavePrepaidReturn(data) {
      this.$refs.viewPrinterSettingModal.show({ ...data, prepaid_return: true });
    },

    async printOrders(id = null, settings = null) {
      let ids = this.serverParams.ids;
      if (id) {
        ids = [id];
      }
      // console.log("ID?", id)
      // console.log("ServerParamsIDS?", ids)
      // console.log("FINAL IDS", ids)
      try {
        const chan = this.batchPrintSubscription;
        if (settings) {
          // max of 125 per outbound + prepaid
          if (settings.returnDetail) {
            ids = ids.slice(0, 125);
          }
          settings = Object.assign({}, settings, { printed_by: this.employee });
          console.log("settings", settings);
          console.log("ids", ids, ids.length);
          try {
            chan.emit("print", { ids, u: this.user.id, settings });
          } catch (e) {
            console.error("Unable to connect to batch printer server");
            if (confirm(`The browser has timed out and lost some connection to server. The application may experience difficulties.
              \r\nPlease refresh the page to resolve.`)) {
              document.location.reload();
            }
          }
        } else {
          try {
            chan.emit("print", {
              ids, u: this.user.id, settings: {
                paper: this.user.shipping_label_format.code || "DOC_4X6",
                bName: `ecommerce-${Date.now()}`,
                base64: true,
                printed_by: this.employee,
                printed_on: 'E-commerce',
              }
            });
          } catch (e) {
            console.error("Unable to connect to batch printer server");
            if (confirm(`The browser has timed out and lost some connection to server. The application may experience difficulties.
              \r\nPlease refresh the page to resolve.`)) {
              document.location.reload();
            }
          }
        }
      } catch (e) {
        if (e.response) {
          let message = e.response.data.message;
          if (e.response.data.errors) {
            message += ": ";
            message += Object.values(e.response.data.errors).join(" ");
          }
          this.$emit("alert", { message: message, type: "danger" });
        } else {
          this.$emit("alert", { message: "Unexpected Error, please try again!", type: "danger" });
        }
      } finally {
        // this.fetchOrders();
        this.refreshUserBalance();
      }
    },
    async deleteOrders() {
      const ids = this.serverParams.ids;
      try {
        const ids = this.serverParams.ids;
        const msg = `You are attempting to delete ${ids.length} records. &nbsp;Selected records will only be deleted within GrandShipper and will not affect your E-Commerce store. &nbsp;You can pull the records back by clicking Update Store button assuming the record is still in the ready to ship status.`;

        if (!Cookies.get(hash(msg))) {
          let dialog = await this.$dialog.confirm(msg, {
            view: 'warning',
            customClass: 'warning-dialog',
          });
          dialog.close();
        }
      } catch (e) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await axios.delete("orders", { data: { orders: ids } });
        console.log('delete response', response);
        this.fetchOrders();
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
        this.serverParams.ids = [];
        this.refreshEcommerceCount();
      }
    },

    async onImported() {
      console.log('onImpted success');
      this.fetchOrders();
      this.$emit("alert", {
        message: "Orders imported!",
        type: "success"
      });
    },
    // MODALS
    showOrder: async function (orderId) {
      try {
        this.isLoading = true;
        // this.isLoading = true;
        const { data } = await axios.get("/orders/" + orderId);
        this.shown = data;
        // this.isLoading = false;
        // wait for the next event cycle before showing modal
        await this.$nextTick();
        this.isLoading = false;
        this.$refs.viewOrderModal.show();
      } catch (e) {
        console.log('view order modal error: ', e.message);
      }
    },
    async onModalPrint(id) {
      console.log('on modal print data from modal: ', id);
      this.shown = null;
      await this.printOrders(id)
    },
    async onSaveAndClose(data) {
      this.shown = null;
      await this.fetchOrders();
    },
    // onShowOrderHide: async function(){
    //   console.log('closing modal');
    //   this.shown = null;
    // },
    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },
    calculateAge(date) {
      return moment.utc(date).fromNow();
    },
    customSelectedRows() {
      if (this.customRange) {
        //! I can't find a better way to remove the vgtSelected
        //! this.$refs.vgtValid.unselectAllInternal() is not working
        for (let i = 0; i < this.rows.length; i++) {
          this.$set(this.rows[i], 'vgtSelected', false);
        }

        const subtractTo = (this.serverParams.page - 1) * this.serverParams.perPage;
        let parseRange = [], start, end;

        this.customRange.split(',').forEach(i => {
          // check if there's a dash in the iteration
          if (i.indexOf('-') > 0) {
            // if the input has multiple dash, it will only get the first two elements
            [start, end] = i.split('-').map(Number)
            //! if the start is greater than end should I swap them?
            if (start <= this.totalRecords && start < end) {
              // if (subtractTo > 0 && start < subtractTo && subtractTo < end) {
              //   start += subtractTo
              // }
              // just making sure to not get the range beyond the total records
              // I might find a way to make sure that the end only gets the last row number on the current page
              if (end > this.totalRecords) {
                end = (this.serverParams.page || 1) * this.serverParams.perPage
              }
              _.range(start, end + 1).forEach(i => {
                i = subtractTo > 0 ? i - subtractTo : i
                parseRange.push(i)
              });
            }
          } else {
            i = parseInt(i);
            if (i <= this.totalRecords) {
              i = subtractTo > 0 ? i - subtractTo : i
              parseRange.push(i)
            }
          }
        })

        console.log("SubtractTo", subtractTo);
        console.log("start,end", start, end);
        console.log("total records", this.totalRecords);
        console.log("selected", parseRange);

        // uniq to remove duplicates in the array
        _.uniq(parseRange).forEach(i => {
          if (this.rows[i - 1]) {
            this.$set(this.rows[i - 1], 'vgtSelected', true);
          }
        })
      }
    },
    showModifyPackageModal() {
      // const selectedRows = this.$refs.vgt.selectedRows
      // const isInternational = selectedRows.some(r => r.shipping_address_country != 'US')
      // if (isInternational) {
      //   this.$emit('alert', {
      //     message: 'Modifying international records is not available.',
      //     type: 'danger'
      //   });
      //   return
      // }

      this.$refs.viewModifyPackageModal.show();
    },
    async saveOrders(data) {
      this.summary_text = ''
      // const chan = this.updateSubscription;
      // chan.emit('update', Object.assign({}, data, { ids: this.serverParams.ids, uid: this.user.id }))
      const base_url = process.env.MIX_INTEG_URL;
      const response = await axios.post(`${base_url}/update-orders`, Object.assign({}, data, { ids: this.serverParams.ids, uid: this.user.id, location: 'ecommerce' }))
    },
    getSignatureName(signature) {
      switch (signature) {
        case 'DelCon':
          return 'Delivery Confirmation'
        case 'Sig':
          return 'Signature'
        case 'ADSIG':
          return 'Adult Signature'
        case 'ADSIGRD':
          return 'Adult Signature with Restricted Delivery'
        case null:
          return 'Waiver of Signature'
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Orders/ReadyToShip.vue